export default {
    data () {
        return {
            swiperOptions: {
                autoplay: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable :true,
                },
                navigation: {
                    nextEl: '.carousel-next',
                    prevEl: '.carousel-prev',
                }
            },
            swiperHotOptions: {
                autoplay: true,
                pagination: {
                    el: '.swiper-hot-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.carousel-hot-next',
                    prevEl: '.carousel-hot-prev',
                }
            },
            swiperActivityOptions: {
                autoplay: true,
                pagination: {
                    el: '.swiper-activity-pagination',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.carousel-activity-next',
                    prevEl: '.carousel-activity-prev',
                }
            }
        }
    }
}
